import { useConfig } from './use_config';

export const useNotificationCount = () => {
  const config = useConfig();
  return config?.user?.notification_count ?? 0;
};
